module.exports = __webpack_public_path__ + "static/scale-model-of-escape-artistry---time-gallery-in-chicago-illinois-5606d1c2d09b8a13898916588126adf0.png";